import { FC } from 'react';
import * as LucideIcons from 'lucide-react';
import { LucideIcon } from 'lucide-react';

// Exclude non-icon exports from the type
type IconName = Exclude<keyof typeof LucideIcons, 'createLucideIcon'>;

interface IconProps {
  name: IconName;
  className?: string;
  size?: number;
}

const Icon: FC<IconProps> = ({ name, className = '', size = 24 }) => {
  const IconComponent = LucideIcons[name] as LucideIcon;

  if (!IconComponent) {
    console.warn(`Icon "${name}" not found`);
    return null;
  }

  return (
    <IconComponent 
      className={`icon ${className}`}
      size={size}
    />
  );
};

export default Icon; 
